module.exports = __webpack_public_path__ + "img/chat-details6.8da66a7e.png";